import { MidasBuyGoodsParams, MidasBuyGoodsResponse } from '@tencent/halo-jsbridge';

/** 调用米大师道具直购接口 */
export function buyGoods(params: MidasBuyGoodsParams): Promise<MidasBuyGoodsResponse> {
  throw new Error('Method not implemented.');
}
